
import CustomSelect from "../../utils/CustomSelect";
import Subscribe from "../../utils/Subscribe";
import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";
import { NewsItem, TYPE_GRID_VIEW, TYPE_LIST_VIEW } from "./NewsItem";
import App from "../../App";


class News{
    constructor(){
        this.main = document.getElementById('news');
        this._subscriptionSticky = document.getElementById('subscription_sticky');
        if(this._subscriptionSticky !=null){
            this._subscribe = new Subscribe(this._subscriptionSticky.querySelector('.subscribe'));
            this._subscriptionSticky.querySelector('.subscription-box__close').addEventListener('click', function(){
                this.parentNode.remove();
            });
        }

        News.categories = JSON.parse(this.main.getAttribute('data-categories'));
        
        this._inputSearch = this.main.querySelector('input[name="search"]');
        this._searchBtn = this.main.querySelector('.search_btn');
        this._selectCategories = new CustomSelect(this.main.querySelector('select[name="categories"]'));

        this._dateRangePicker = flatpickr(this.main.querySelector('input[name="datepicker"]'), {
            locale: App.lang,
            monthSelectorType: 'static',
            yearSelectorType: 'static',
            mode: 'range',
            onClose: this._onCloseDateRagePicker.bind(this)
        });

        this._dateRangePickerValue = '';

        this._gridViewBtn = this.main.querySelector('.grid_view_btn');
        this._listViewBtn = this.main.querySelector('.list_view_btn');

        this._holderItems = document.getElementById('news_holder_items');

        this._loadMoreBtn = document.getElementById('news_load_more_btn');        
        
        this._currentPage = 1;
        this._totalPages = 0;

        this._items = [];

        this._timeout = null;
        
        this._currentViewType = TYPE_GRID_VIEW;

        this._onHashChange();

        this._loadPage(this._currentPage);

        this._inputSearch.addEventListener('keydown', this._onKeyDownInputSearch.bind(this));
        this._searchBtn.addEventListener('click', this._onClickSearchBtn.bind(this));
        this._selectCategories.addEventListener('change', this._onChangeSelectCategories.bind(this));
        this._gridViewBtn.addEventListener('click', this._onClickGridViewBtn.bind(this));
        this._listViewBtn.addEventListener('click', this._onClickListViewBtn.bind(this));
        this._loadMoreBtn.addEventListener('click', this._onClickLoadMoreBtn.bind(this));
        window.addEventListener('hashchange', this._onHashChange.bind(this));
    }

    _loadPage(page){
        if(page == 1){
            this._holderItems.innerHTML = '';
            this._items = [];
        }

        let dateFrom, dateTo;

        if(this._dateRangePicker.selectedDates.length > 0){
            dateFrom = this._dateRangePicker.selectedDates[0].toISOString().split('T')[0]
            dateTo = this._dateRangePicker.selectedDates[1].toISOString().split('T')[0]
        }else{
            dateFrom = '';
            dateTo = '';
        }

        let params = {
            search: this._inputSearch.value,
            category: this._selectCategories.value,
            dateFrom: dateFrom,
            dateTo: dateTo,
            page: page,
            count: page == 1, //Si es la primera carga con esos filtros pide que devuelva count pages
            lang: App.lang
        }

        let query = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        

        fetch(`${App.baseUrl}posts-&-news/news?${query}`,{
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
        .then(response => response.json())
        .then((data)=>{
            if(page == 1){
                this._totalPages = data.total_pages;
            }
            
            this._currentPage = page;

            data.items.forEach((itemData, index)=>{
                let item = new NewsItem(itemData, this._currentViewType, index);
                this._holderItems.appendChild(item.main);

                this._items.push(item);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)

            if(this._currentPage == this._totalPages || this._totalPages == 0){
                this._loadMoreBtn.style.display = 'none';
            }else{
                this._loadMoreBtn.style.display = 'inline-flex';
            }

            if(data.items.length == 0){
                this.main.classList.add('page--no-results');
            }else{
                this.main.classList.remove('page--no-results');
            }

        })
    }

    _onHashChange(e){
        let search = decodeURIComponent(window.location.hash.substr(1));

        if(search != ''){
            history.pushState('', document.title, window.location.pathname);
            this._inputSearch.value = search;

            this._loadPage(1);
        }
    }

    _onClickLoadMoreBtn(e){
        e.preventDefault();

        this._loadPage(this._currentPage + 1);
    }

    _onKeyDownInputSearch(e){
        clearTimeout(this._timeout);
        this._timeout = setTimeout(()=>{
            this._loadPage(1);
        }, 200);
    }

    _onClickSearchBtn(e){
        this._loadPage(1);
    }

    _onChangeSelectCategories(e){
        this._loadPage(1);
    }

    _onClickGridViewBtn(e){
        e.preventDefault();
        
        if(this._currentViewType != TYPE_GRID_VIEW){
            this._currentViewType = TYPE_GRID_VIEW;
            
            this._gridViewBtn.classList.add('btn-square--active');
            this._listViewBtn.classList.remove('btn-square--active');
            
            this._items.forEach((item)=>{
                item.setViewType(TYPE_GRID_VIEW);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)
        }
    }

    _onClickListViewBtn(e){
        e.preventDefault();

        if(this._currentViewType != TYPE_LIST_VIEW){
            this._currentViewType = TYPE_LIST_VIEW;
            
            this._listViewBtn.classList.add('btn-square--active');
            this._gridViewBtn.classList.remove('btn-square--active');
            
            this._items.forEach((item)=>{
                item.setViewType(TYPE_LIST_VIEW);
            })

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)
        }
    }

    _onCloseDateRagePicker(e){
        setTimeout(()=>{
            this._loadPage(1);
        }, 100)
    }
}

export default News;